// extracted by mini-css-extract-plugin
module.exports = {"stack":"Stack_stack__11QhO","fill":"Stack_fill__hjZv4"};